export default __webpack_public_path__ + "7b934a11ad28dafbd108b389579c8b45.png";